module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14.8002 3.70018L11.7865 0.799805L1.80315 11.7181L1.2002 15.1998L4.81547 14.6199L14.8002 3.70018ZM10.8156 3.64284L11.8416 2.52079L13.1226 3.75369L12.0966 4.87574L10.8156 3.64284ZM10.0043 4.53009L2.92815 12.2689L2.67216 13.7471L4.21055 13.5003L11.2854 5.76299L10.0043 4.53009Z\" fill=\"currentColor\"/>"}
const React = require('react');

function svgLoader(svg) {
	const { viewBox, width, height } = svg.attributes;

	// eslint-disable-next-line react/display-name
	return function (props) {
		return React.createElement(
			'svg',
			Object.assign(
				{
					dangerouslySetInnerHTML: { __html: svg.content },
					fill: 'currentColor',
					height,
					viewBox,
					width,
				},
				props,
			),
		);
	};
}

module.exports = svgLoader(module.exports);
